import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = [
        "placeholder", "lookup", "cancel", "section", "name", "city", "type", "search"
    ]

    connect()
    {
        window.hello = this.application;
        this.lookupTarget.addEventListener("click", e =>
        {
            this.sectionTarget.classList.remove("hidden");
            this.lookupTarget.classList.add("hidden");
            this.cancelTarget.classList.remove("hidden");
        })

        this.cancelTarget.addEventListener("click", e =>
        {
            this.sectionTarget.classList.add("hidden");
            this.cancelTarget.classList.add("hidden");
            this.lookupTarget.classList.remove("hidden");
        });

        this.searchTarget.addEventListener("click", e =>
        {
            let div = document.createElement("div");
            div.classList.add("circle-loader", "small-loader");

            this.searchTarget.parentElement.appendChild(div);
            this.searchTarget.classList.add("hidden");

            let data = {
                agency_name: this.nameTarget.value,
                city: this.cityTarget.value,
                agency_type: this.typeTarget.querySelector(`input[name="agency_type"]`).value,
                name: "agency_search"
            }

            fetch(window.App.prefixedUrl(`/view-data/agency-search?agency_name=${data.agency_name}&city=${data.city}&agency_type=${data.agency_type}&name=agency_search`),
            {
                method: "get"
            })
            .then(data => 
            {
                if(!data.ok) throw new Error("request failed");
                return data.text();
            })
            .then(data =>
            {
                this.placeholderTarget.innerHTML = data;
                setTimeout(() =>
                {   
                    let controller = this.application.getControllerForElementAndIdentifier(this.placeholderTarget.firstElementChild, "custom-select");
                    controller.openDropdown(controller.dropdownTarget, controller.arrowTarget, controller.inputTarget);
                }, 100);
                            
            })
            .catch(e =>
            {
                let toastEvent = new CustomEvent("show-toast", { detail: "An error occurred:\n" + e.message })
                window.dispatchEvent(toastEvent);
                this.placeholderTarget.innerHTML = `<input class="form-input" type="text" name="agency_search" id="agency_search">`
            })
            .finally(() =>
            {
                this.searchTarget.parentElement.lastElementChild.remove();
                this.searchTarget.classList.remove("hidden");
            })
            
        })
    }
}